<template>
    <v-dialog class="login" persistent max-width="350" :value="!isLoggedIn">
        <Login @loaded="$emit('loaded')"></Login>
    </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Login from './Login'

  export default {
    name: 'LoginModal',
    components: { Login },
    computed: {
      ...mapGetters({
        isLoggedIn: 'user/isLoggedIn'
      })
    }
  }
</script>
